export default "__VITE_ASSET__BtHJToiC__"